import { ChangeDetectorRef, Component, DoCheck, ElementRef, HostListener, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConstantsService } from '../app-constants.service';
import { AppState } from '../app.service'
import { UtilityService } from '../common-services/utility.service';
import { DailyStepsService } from '../daily-steps/daily-steps.service';
import { Habit } from '../habit/habit.model';
import { HomeV5Service } from '../pages/home-v5/home-v5.service';
import { Path } from '../path/path-v2.model';
import { AnalyticsServiceService } from '../services/analytics-service.service';
import { SpinnerService } from '../spinner.service';
import { ToasterService } from '../toaster.service';
import { User } from '../user/user.model';
import { zoomInAnimation, expandOnEnterAnimation, slideOutDownAnimation, slideInLeftAnimation } from 'angular-animations';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { I18n } from '../i18n.service';
import { HomeUiService } from '../new-design/home-ui.service';
import { ModalController, IonTextarea,Platform } from '@ionic/angular';
import * as _ from 'underscore';
import { SessionService } from '../session/session.service';
import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';
import { RoutineService } from 'src/app/daily-content-v2/routine.service';
import mixpanel from 'mixpanel-browser';
import { DailyStepsContentWebModalV2Component } from '../new-design/daily-steps-content-web-modal-v2/daily-steps-content-web-modal-v2.component';
import { KyperDataApiService } from '../services/kyper-data-api.service';

@Component({
  selector: 'app-weldonescreen',
  templateUrl: './weldonescreen.component.html',
  styleUrls: ['./weldonescreen.component.scss'],
  animations: [
    zoomInAnimation(),
    trigger('shrinkAnimation', [
      state('normal', style({
        transform: 'scale(1)',
      })),
      state('shrunken', style({
        transform: 'scale(0.7)', // Adjust the scale factor as needed
      })),
      transition('normal => shrunken', [
        animate('0.3s ease-out')
      ]),
      transition('shrunken => normal', [
        animate('0.3s ease-in')
      ]),
    ]),
    expandOnEnterAnimation({ duration: 400 }),
    slideOutDownAnimation({ duration: 500 }),
    slideInLeftAnimation({duration:400})
  ]
})
export class WeldonescreenComponent implements OnInit, DoCheck,OnDestroy {
  currentUser: User;
  currentPath: Path;
  @Input()currentDay: number;
  currentHabit: number
  actionPoints: number
  showStepTitle = true;
  postText: any = ''
  formRating: any = 0
  maxAllowedScheduleDay: any;
  scheduleDay: number;
  scheduledStep: any;
  nextDay: number;
  inoutScreen: any;
  titleOfTask: any;
  allowScreenCount: boolean
  dayHasContent;
  previousDayCompleted;
  public pathRegistration: any;
  options: [
    {
      label: 'Zoom Entrances',
      animations: ['zoomIn']
    },
  ]
  @Input() currentOpenedChapter;
  @Input() currentOpenedStep;
  @ViewChild('gifImage') gifImage: ElementRef;
  // @ViewChild('textarea', { static: false }) textarea: IonTextarea;
  @ViewChild("textarea") txtarea: ElementRef;
  animateZoomIn = false
  showRatingBox = false
  @ViewChild('ratingArea', {static: false}) ratingArea: ElementRef;
  isShrunken = false;
  expandTextArea = false
  showTyLabel = false
  dailyStepsArray;
  isIconDisliked: boolean = false;
  isIconLiked: boolean = false;
  mobileWeldoneScreenIds: string[] = [];
  isLastStepInChapter: boolean = false;
  isBadgesExpanded;
  unlockStepInoutScreenData;
  durationOfTask;
  unAttemptedActionPoints = {};
  totalUnAttemptedPoints = 0;
  currentStepActionPoints;
  stepScreensIds
  showBottomTextarea = false
  showInstruction = false;
  currentScreenIndex = 0;
  animationBoard = false;
  reviewState = false;
  currentNumber = 0;
  isAndroidTablet = false;
  isScreenVisited = false;
  streaksInfo;
  isStreaksScreenVisited = false;
  updatedStreaksWeeksData;
  showFirstDayInWeekStreakCompletedCount = false;
  showWeeklyStreakCompletedCount = false;
  currentClient;
  activeChapterIndex;
  stepIndex;
  @ViewChild("stepTitle") stepTitle: ElementRef;
  constructor(
    private appState: AppState,
    public route: ActivatedRoute,
    private router: Router,
    private i18n: I18n,
    private dialog: MatDialog,
    private spinnerService: SpinnerService,
    public homeUIService: HomeUiService,
    private homev5Service: HomeV5Service,
    private cdRef: ChangeDetectorRef,
    private toasterService: ToasterService,
    private dailyStepsService: DailyStepsService,
    private analyticsService: AnalyticsServiceService,
    private modalController: ModalController,
    private utilService: UtilityService,
    private appConstantService: AppConstantsService,
    private renderer: Renderer2,
    private routineService: RoutineService,
    public sessionService: SessionService,
    private elementRef: ElementRef,
    private keyboard: Keyboard,
    private platform: Platform,
    private kyperApiService: KyperDataApiService
  ) {
    this.pathRegistration = this.appState.get('pathRegistration')
    this.currentUser = this.appState.get('currentUser');
    this.currentPath = this.appState.get('currentPath');
    // this.currentDay = this.appState.get('currentScheduleDay')
    this.scheduledStep = this.appState.get('scheduleDayForCurrentStep');
    this.maxAllowedScheduleDay = this.appState.get('daysOfContent')
    this.scheduleDay = +this.appState.get('currentScheduleDay')
    this.dailyStepsArray = this.appState.get('DailyStepsData')
    this.activeChapterIndex = this.appState.get('currentActiveChapter')
    // this.stepIndex = this.appState.get('reviewingStepIndex')
    // if (this.currentDay < this.currentPath?.lastDayOfContent() && this.dailyStepsArray[this.activeChapterIndex]?.steps?.length > this.stepIndex + 1) {
    //   this.inoutScreen = this.dailyStepsArray[this.activeChapterIndex]?.steps[this.stepIndex + 1]?.step
    // }
    // else if (this.currentPath?.lastDayOfContent() > this.activeChapterIndex+1 && this.dailyStepsArray[this.activeChapterIndex+1]?.steps?.length > 0) {
    //   this.inoutScreen = this.dailyStepsArray[this.activeChapterIndex+1]?.steps[0]?.step
    // }
    this.isAndroidTablet = this.platform.is('mobileweb') && ( this.platform.is('tablet'))
    if (this.appState.get('routine_schedule_day')) {
      this.currentDay = this.appState.get('routine_schedule_day')
      this.appState.set('routine_schedule_day', null)
    }
    // for(let i=this.currentDay + 1; i<= this.maxAllowedScheduleDay; i++) {
    //  // this.dayHasContent = this.currentPath.checkContentForDay(i);
    //   if(this.dayHasContent) {
        this.nextDay = this.currentDay + 1;
        this.scheduleDay =this.currentDay + 1;
    //     break;
    //   }
    // }
    this.stepScreensIds = this.appState.get("stepScreenIds");
    this.scheduledStep = this.appState.get('scheduleDayForCurrentStep')  
   // this.currentStepActionInfo();
  }

  currentStepActionInfo() {
    // let data = {
    //   'user_id': this.currentUser.id,
    //   'path_id': this.currentPath.id,
    //   'currentDay': this.currentDay
    // }
    // this.homeUIService.getStepwiseActionPoint(data).subscribe((res) => {
    let step_id = this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.currentOpenedStep]?.step?.id
    this.homeUIService.getKyperStepwiseActionPoint(step_id).subscribe((res) => {
      this.currentStepActionPoints = res?.data;
      if (this.currentStepActionPoints?.total > 0) {
        this.startCounterAnimation(this.currentStepActionPoints?.total)
      }
      let poll, content, notification, profile, accountability, managerEmail, habit, action, assessment, reflection, question, nps;
      habit = this.stepScreensIds?.find((item) => item?.type === "routine");
      poll = this.stepScreensIds?.find((item) => item?.type === "poll");
      content = this.stepScreensIds?.find((item) => item?.type === "content");
      notification = this.stepScreensIds?.find((item) => item?.type === "notification");
      profile = this.stepScreensIds?.find((item) => item?.type === "profile");
      accountability = this.stepScreensIds?.find((item) => item?.type === "accountability");
      managerEmail = this.stepScreensIds?.find((item) => item?.type === "managerEmail");
      action = this.stepScreensIds?.find((item) => item?.type === "action");
      reflection = this.stepScreensIds?.find((item) => item?.type === "reflection");
      assessment = this.stepScreensIds?.find((item) => item?.type === "survey");
      question = this.stepScreensIds?.find((item) => item?.type === "question");
      nps = this.stepScreensIds?.find((item) => item?.type === "nps");
      if ((this.currentStepActionPoints?.details?.content == 0 || !this.currentStepActionPoints?.details?.content) && content) {
        this.totalUnAttemptedPoints += content.actionPoints;
        this.unAttemptedActionPoints['content'] = content.actionPoints;
      }
      if (habit) {
        this.totalUnAttemptedPoints += habit?.actionPoints;      
        this.unAttemptedActionPoints['habit'] = habit?.actionPoints;
      }
      if (poll) {
        if (this.currentStepActionPoints?.details?.poll == 0 || !this.currentStepActionPoints?.details?.poll) {
           this.totalUnAttemptedPoints += poll.actionPoints;
           this.unAttemptedActionPoints['poll'] = poll.actionPoints;
        }
        else if (this.currentStepActionPoints?.details?.poll > 0) {
          // let pointsDiff = poll.actionPoints - this.currentStepActionPoints?.details?.poll;
          // if (pointsDiff!=0) {
             this.totalUnAttemptedPoints += poll.actionPoints;
             this.unAttemptedActionPoints['poll'] = poll.actionPoints;
          // }
          // else {
            //  this.totalUnAttemptedPoints += pointsDiff;
            //  this.unAttemptedActionPoints['poll'] = pointsDiff;
         //   }
         
        }
       
      }
      if ((this.currentStepActionPoints?.details?.notifications == 0 || !this.currentStepActionPoints?.details?.notifications) && notification) {
        this.totalUnAttemptedPoints += notification.actionPoints; 
        this.unAttemptedActionPoints['notifications'] = notification.actionPoints;
      }
      if ((this.currentStepActionPoints?.details?.profile == 0 || !this.currentStepActionPoints?.details?.profile) && profile) {
        this.totalUnAttemptedPoints += profile.actionPoints; 
        this.unAttemptedActionPoints["profile"] = profile.actionPoints;
      }
      if ((this.currentStepActionPoints?.details?.accountabilityEmail == 0 ||  !this.currentStepActionPoints?.details?.accountabilityEmail)&& accountability) {
        this.totalUnAttemptedPoints += accountability.actionPoints; 
        this.unAttemptedActionPoints['accountability'] = accountability.actionPoints;
      }
      if ((this.currentStepActionPoints?.details?.managerEmail == 0 || !this.currentStepActionPoints?.details?.managerEmail) && managerEmail) {
        this.totalUnAttemptedPoints += managerEmail.actionPoints; 
        this.unAttemptedActionPoints['managerEmail'] = managerEmail.actionPoints;
      }
      if ((this.currentStepActionPoints?.details?.action == 0 || !this.currentStepActionPoints?.details?.action) && action) {
        this.totalUnAttemptedPoints += action.actionPoints; 
        this.unAttemptedActionPoints['action'] = action.actionPoints;
      }
      if ((this.currentStepActionPoints?.details?.assessment == 0 || !this.currentStepActionPoints?.details?.assessment)&& assessment) {
      this.totalUnAttemptedPoints += assessment.actionPoints; 
      this.unAttemptedActionPoints['assessment'] = assessment.actionPoints;
    }
      if ((this.currentStepActionPoints?.details?.reflection == 0 || !this.currentStepActionPoints?.details?.reflection)&& reflection) {
       this.totalUnAttemptedPoints += reflection.actionPoints; 
       this.unAttemptedActionPoints['reflection'] = reflection.actionPoints;
     }
      if ((this.currentStepActionPoints?.details?.socialDiscussion == 0 || !this.currentStepActionPoints?.details?.socialDiscussion) && question) {
       this.totalUnAttemptedPoints += question.actionPoints; 
       this.unAttemptedActionPoints['socialDiscussion'] = question.actionPoints;
      }
      if ((this.currentStepActionPoints?.details?.nps == 0 || !this.currentStepActionPoints?.details?.nps) && nps) {
        this.totalUnAttemptedPoints += nps.actionPoints;
        (this.unAttemptedActionPoints as any)['nps'] = nps.actionPoints;
      }
      const pathPersonalization: any = this.stepScreensIds?.find((item: any) => item?.type === 'pathPersonalization');
      if (!this.currentStepActionPoints?.details?.pathPersonalization && pathPersonalization?.actionPoints) {
        this.totalUnAttemptedPoints += pathPersonalization.actionPoints;
        (this.unAttemptedActionPoints as any)['pathPersonalization'] = pathPersonalization.actionPoints;
      }

    })
  }
  startCounterAnimation(targetNumber) {
    const element = document.querySelector('.number') as HTMLElement;
    if (element) {
      // element.style.setProperty('--num', targetNumber.toString());
      setTimeout(() => {
        this.animateCounter(0, targetNumber, 1000);
      }, 2150); 
    }
  }

  animateCounter(start: number, end: number, duration: number) {
    const stepTime = Math.abs(Math.floor(duration / (end - start)));
    let current = start;
    const step = () => {
      current += 1;
      this.currentNumber = current;
      if (current < end) {
        setTimeout(step, stepTime);
      }
    };
    step();
  }
  ngOnInit() {
    this.dailyStepsArray = this.appState.get('DailyStepsData')
    this.activeChapterIndex = this.appState.get('currentActiveChapter')
    this.stepIndex = this.appState.get('reviewingStepIndex')
     this.currentClient = this.appState.get('currentClient')
    let isStepRestartedFromWeldone = this.appState.get("isCurrentStepRestarted")
    let isInitialWeldoneScreen = this.appState.get('showInitialWeldone')
    this.streaksInfo = this.appState.get('dailyStreaksInfo');
    console.log("this.appState.get('isStreaksInfoUpdated')", this.streaksInfo, this.appState.get('isStreaksInfoUpdated'))
    // if ((this.scheduledStep == this.currentDay &&this.dailyStepsArray[this.currentDay]?.stepStatus==undefined )|| (this.scheduledStep == this.currentDay+1 && this.dailyStepsArray[this.currentDay]?.stepStatus==undefined )|| isStepRestartedFromWeldone ) {
    if (isStepRestartedFromWeldone || isInitialWeldoneScreen) {
     if (this.currentPath?.enabledAttributes?.action_hub && !(this.currentPath?.enabledAttributes?.action_hub == undefined)) {
        this.mobileWeldoneScreenIds = [
          'actionHubScreen',
          "step-action-points-screen",
          //  "step-badges-screen",
          "step-final-weldone-screen",
          //  "step-review-weldone-screen",
        ];
      }
      else {
        this.mobileWeldoneScreenIds = [
          "step-action-points-screen",
          //  "step-badges-screen",
          "step-final-weldone-screen",
          //  "step-review-weldone-screen",
        ];
     }
      if (this.appState.get('isStreaksInfoUpdated') || !this.streaksInfo?.todays_streak) {
        this.appState.set('isStreaksInfoUpdated',false)
        this.mobileWeldoneScreenIds.splice( this.mobileWeldoneScreenIds?.length-1,0,'step-streaks-screen')
      }
      // Locate the completed step by its position for reliable chapter detection. uncomment at the time of release after testing
      let reviewedChapterIdx: number = -1;
      let reviewedStepIdx: number = -1;
        reviewedChapterIdx = this.currentOpenedChapter;
        reviewedStepIdx   = this.currentOpenedStep;

      const reviewedChSteps: any[] = this.dailyStepsArray?.[reviewedChapterIdx]?.steps ?? [];
      const isLastStepOfChapter = reviewedStepIdx >= 0 && (reviewedStepIdx + 1) >= reviewedChSteps.length;
      const hasNextChapter = (reviewedChapterIdx + 1) < (this.dailyStepsArray?.length ?? 0) &&
        (this.dailyStepsArray?.[reviewedChapterIdx + 1]?.steps?.length ?? 0) > 0;
      if (isLastStepOfChapter) {
        this.appState.set('completingChapterIndex', reviewedChapterIdx);
      }
      if (isLastStepOfChapter && hasNextChapter) {
        this.isLastStepInChapter = true;
        this.mobileWeldoneScreenIds.splice(this.mobileWeldoneScreenIds.length - 1, 0, 'step-chapter-complete-screen');
      }
      // Seen. Recorded the moment the first-time view is SHOWN, not on the way out: leaving can be a
      // page-level navigation or a refresh, neither of which runs ngOnDestroy, and the learner would
      // then be shown it again on every reopen. The back arrow undoes this.
      this.markEndOfStepSeen()
      this.showingFirstVisitEndOfStep = true
      this.appState.set("showInitialWeldone", false)
      this.appState.set("isCurrentStepRestarted", false);
    console.log("this.mobileWeldoneScreenIds", this.mobileWeldoneScreenIds, this.mobileWeldoneScreenIds['action-points-screen']);
   }
    else {
      if (this.currentPath?.enabledAttributes?.action_hub && !(this.currentPath?.enabledAttributes?.action_hub == undefined)) {
        this.mobileWeldoneScreenIds = [
          'actionHubScreen',
          'step-review-weldone-screen'
        ]
      }
      else {
        this.mobileWeldoneScreenIds = [
          'step-review-weldone-screen'
        ]
      }
    }
     
  // let reviewedChapterIdx: number = -1;
  //     let reviewedStepIdx: number = -1;
  //       reviewedChapterIdx = this.currentOpenedChapter;
  //       reviewedStepIdx   = this.currentOpenedStep;

  //       this.appState.set('completingChapterIndex', reviewedChapterIdx-1);
  //               this.isLastStepInChapter = true;

  //       this.mobileWeldoneScreenIds.splice(this.mobileWeldoneScreenIds.length - 1, 0, 'step-chapter-complete-screen');
    this.dailyStepsService.init()
    this.analyticsService.setScreen(AnalyticsServiceService.WELDONE)
    this.appState.set('allowNext', false)
    if (!this.currentPath?.enabledAttributes?.action_hub || this.currentPath?.enabledAttributes?.action_hub == undefined) {
      this.getActions(this.currentPath.id)
    }
  }
  private capitalizeSentences(text: string): string {
    return text.replace(/(?:^|\.\s)([a-z])/g, (match) => match.toUpperCase());
  }
  capitalLine(event): void {
    if (event && event.target.value) {
      this.postText = this.capitalizeSentences(event.target.value);
    }
    const ta = event.target as HTMLTextAreaElement;
    ta.rows = 1;
    const style = getComputedStyle(ta);
    const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.4;
    const padding = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
    const rows = Math.ceil((ta.scrollHeight - padding) / lineHeight);
    ta.rows = Math.min(Math.max(rows, 1), 4);
    ta.style.overflowY = rows > 4 ? 'auto' : 'hidden';
  }
  // onTextModification(ev) {
  //   console.log("called on change", ev.target.value);
  //   this.capitalLine(ev)
  // }
  getStepTitle(status) {
    if(status=='locked') {
      if (this.dailyStepsArray[this.currentOpenedChapter]?.steps?.length > this.currentOpenedStep + 1) {
        return this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.currentOpenedStep+1]?.step?.title
      }
      else {
        return this.dailyStepsArray[this.currentOpenedChapter + 1]?.steps[0]?.step?.title
      }
    }
    else { 
    return this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.currentOpenedStep]?.step?.title
    }
  }

  getLastStepPosition() {
    return this.dailyStepsArray[this.dailyStepsArray?.length-1]?.steps[this.dailyStepsArray[this.dailyStepsArray?.length-1]?.steps?.length-1]?.position
  }
  getStepImage(status) {
    if(status=='locked') {
      if (this.dailyStepsArray[this.currentOpenedChapter]?.steps?.length > this.currentOpenedStep + 1) {
        return this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.currentOpenedStep+1]?.step?.image
      }
      else {
        return this.dailyStepsArray[this.currentOpenedChapter+1]?.steps[0]?.step?.image
      }
    }
    else {
     return this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.currentOpenedStep]?.step?.image
    }
  }
    getStepDescription(status) {
    if(status=='locked') {
      if (this.dailyStepsArray[this.currentOpenedChapter]?.steps?.length > this.currentOpenedStep + 1) {
        return this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.currentOpenedStep+1]?.step?.description
      }
      else {
        return this.dailyStepsArray[this.currentOpenedChapter+1]?.steps[0]?.step?.description
      }
    }
    else {
     return this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.currentOpenedStep]?.step?.description
    }
  }
  ngDoCheck() {
    this.allowScreenCount = this.appState.get('allowScreenCount')
    this.dailyStepsArray = this.appState.get('DailyStepsData')
    //  this.activeChapterIndex = this.appState.get('currentActiveChapter')
    // this.stepIndex = this.appState.get('reviewingStepIndex')
    // this.currentDay = this.appState.get('currentScheduleDay')
     if (this.mobileWeldoneScreenIds && this.mobileWeldoneScreenIds[this.currentScreenIndex]=='step-action-points-screen' && !this.isScreenVisited) {
      this.isScreenVisited = true;
      this.currentStepActionInfo()
     }
    if (this.mobileWeldoneScreenIds && this.mobileWeldoneScreenIds[this.currentScreenIndex]=='step-streaks-screen' && !this.isStreaksScreenVisited) {
      this.isStreaksScreenVisited = true;
      this.currentStepStreaksInfo()
    }
  }
  currentStepStreaksInfo() {
    this.updatedStreaksWeeksData = this.appState.get('updatedStreaksInfo');
    if (this.updatedStreaksWeeksData?.is_first_day_in_week_streak_completed && this.updatedStreaksWeeksData?.streak_dates?.length ==1) {
      this.showFirstDayInWeekStreakCompletedCount = true;
    }
    if (this.updatedStreaksWeeksData?.streak_dates?.length>=5) {
      this.showWeeklyStreakCompletedCount = true;
    }
    mixpanel.track('EOS streaks screen enabled', { streaksInfo: this.updatedStreaksWeeksData, isFirstDayInWeekStreakCompleted: this.showFirstDayInWeekStreakCompletedCount, isWeeklyStreakCompleted: this.showWeeklyStreakCompletedCount })
  }

  ngAfterViewInit() {
    setTimeout(() => {
      // STOP confetti animation
      // this.renderer.setStyle(this.gifImage.nativeElement, 'background-image', 'none'); // Change color property
      // this.renderer.setStyle(this.gifImage.nativeElement, 'background-color', '#fff'); // Change color property
      // this.renderer.setStyle(this.gifImage.nativeElement, 'display', 'none'); // Change color property
      if (this.gifImage?.nativeElement) {
        this.renderer.removeClass(this.gifImage?.nativeElement, 'confitee-animation');
      }
      //Enable rating area with zoomIn animation
      this.showRatingBox = true
      this.animateZoomIn = false
      setTimeout(() => {
        this.animateZoomIn = true
      }, 10);

    }, 2000);
    this.nextDay = this.currentDay + 1;
    this.scheduleDay = this.currentDay + 1;
        if (this.currentDay < this.currentPath?.lastDayOfContent() && this.dailyStepsArray[this.currentOpenedChapter]?.steps?.length > this.currentOpenedStep + 1) {
      this.inoutScreen = this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.currentOpenedStep + 1]?.step
    }
    else if (this.currentPath?.lastDayOfContent() > this.currentOpenedChapter+1 && this.dailyStepsArray[this.currentOpenedChapter+1]?.steps?.length > 0) {
      this.inoutScreen = this.dailyStepsArray[this.currentOpenedChapter+1]?.steps[0]?.step
    }
    this.checkBottomHeight()
  }

  findForCurrentDay(collection: any): any {
    return collection.find(
      item => item.startDay <= this.currentDay + 1 && this.currentDay + 1 <= item.endDay
    )
  }

  goToHome(formRating: any) {
    this.appState.set('isNewStep', undefined)
    this.appState.set('isHomeScreen',true)
    if (formRating) {
      this.onSumbit()
    }else{
      this.modalController.dismiss();
      //this.router.navigate(['/main'])
    }
    this.appConstantService.removeAppStateData()
    if (this.allowScreenCount && this.currentDay ==this.scheduledStep && this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.currentOpenedStep]?.stepStatus!='Review'){
      this.utilService.setScreenCount()
    }
  }

  onSumbit() {
    localStorage.setItem('step_comment', this.postText);
    localStorage.setItem('step_score', JSON.stringify(this.formRating));
    this.giveFeedback()
  }

  findLastHabit(collection: any, lastDay: any): any {
    return collection.find(
      item => item.startDay <= lastDay && lastDay <= item.endDay
    )
  }

  findCurrentPlatform(){
    const ua = navigator.userAgent.toLowerCase();
    const hasTouch = navigator.maxTouchPoints > 1 || 'ontouchstart' in window;
    //const platform = window.navigator.platform.toLowerCase();
    // Actual tablets (Android Tablets, iPads)
    const isTablet = /ipad|android(?!.*mobi)|tablet/i.test(ua);
    const checkWeb = ua?.includes("win") || ua?.includes("window") || ua?.includes("mac") || ua?.includes("macintel")

    // Exclude touch laptops (Windows/macOS laptops with touchscreens)
    const isLaptop = hasTouch && !isTablet && /windows|mac os|linux/i.test(ua);
    if(this.platform.is("mobileweb") && this.platform.is("ipad")&& (!isLaptop || !this.platform.is('desktop'))){
      return 'web-ipad';
    } else if(this.platform.is("mobileweb") && this.platform.is("tablet")&& (!isLaptop || !this.platform.is('desktop'))){
      return 'web-tablet';
    } else if(this.platform.is("mobileweb") && this.platform.is("ios") && !this.platform.is("ipad")){
      return 'web-ios';
    } else if(this.platform.is("mobileweb") && this.platform.is("android") && !this.platform.is("tablet")){
      return 'web-android';
    } else if(this.platform.is("ios") && this.platform.is("mobile")){
      return 'ios';
    } else if(this.platform.is("android") && this.platform.is("mobile")){
      return 'android';
    } else {
      return 'web';
    }
  }

  isDayLocked(nextDay) {
    // if (this.allowScreenCount) {
    //   this.utilService.setScreenCount()
    // }
    this.appState.set('isHomeScreen',true)
    var currentDay = nextDay - 1
    let stepStatus;
    if (this.dailyStepsArray[this.currentOpenedChapter]?.steps?.length > this.currentOpenedStep + 1) {
        this.appState.set('reviewingStepIndex', this.currentOpenedStep + 1)
        stepStatus = this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.currentOpenedStep + 1]?.stepStatus
      }
      else {
      this.appState.set('reviewingStepIndex', 0)
      this.appState.set('currentActiveChapter', this.currentOpenedChapter + 1)
      stepStatus = this.dailyStepsArray[this.currentOpenedChapter + 1]?.steps[0]?.stepStatus
      }
    let levelSaveData = this.appState.get('levelSaveData')
    console.log('levelSaveData :', levelSaveData);
    if (levelSaveData) {
      localStorage.setItem(
        `Toggle:Day:${levelSaveData.currentDay}:LevelNumber:${levelSaveData.levelId}:true`,
        'true'
      )
      this.appState.set('showUpdatedScreens', undefined)
      this.appState.set('levelSaveData', undefined)
    }
    if (nextDay >= this.scheduledStep && this.scheduledStep <= this.maxAllowedScheduleDay && (stepStatus==undefined || stepStatus==null)) {
      localStorage.setItem('isBeginClicked', 'true')
      mixpanel.track("Clicked on Next button at EOS to unlock next step",{currentDay:currentDay, unlockingStepDay: nextDay})
      this.appState.set('currentActiveStepIndex', this.appState.get('reviewingStepIndex'))
      this.unlockReplay(currentDay)
    } else {
      mixpanel.track("Reviewing the next completed step from EOS",{currentDay:currentDay, unlockingStepDay: nextDay})
      this.appState.set("currentScheduleDay",nextDay)
      this.replay(nextDay)
    }
  }

  returnToHome() {
    this.appState.set('currentActiveStepIndex', this.appState.get('currentActiveStepIndex'));
    this.modalController.dismiss();
    let dailySteps = this.appState.get("DailyStepsData");
    dailySteps.forEach((step)=>{
      if(step?.stepStatus =='Review' )
      {
          mixpanel.track("Clicked on home button at EOS",{scheduledStepFor:step?.step+1})
          this.appState.set('currentScheduleDay', step?.step+1);
          this.appState.set('scheduleDayForCurrentStep',  step?.step+1);
      }
    })
   
  }


  replay(i) {
    let updateScheduleDay=i;
    // Deliberately writes no step indexes here. `currentActiveChapter` means the learner's ACTIVE
    // chapter (home-ui owns it); leaving a reviewed step's chapter in it made the home screen open
    // the active step on the wrong chapter. Both step components resolve their own indexes from the
    // step position instead.
    this.appState.set('maxAllowedScheduleDay', updateScheduleDay);
    this.appState.set('currentScheduleDay', updateScheduleDay);
    // this.appState.set('scheduleDayForCurrentStep', updateScheduleDay);
    this.scheduledStep = this.appState.get('scheduleDayForCurrentStep');
    localStorage.removeItem(
      `Toggle:User:${this.currentUser.id}:DayProgress:${this.currentPath.id}:${!(i == undefined) ? i : this.scheduleDay
      }`
    );
    // this.router.navigate([
    //   '/content',
    //   !(i == undefined) ? i : this.scheduledStep,
    // ])
    this.modalController.dismiss({isOpenNextStep:true});
    this.homeUIService.openDailyStepsComponent(DailyStepsContentWebModalV2Component,{currentDay:i},'web-daily-steps-custom-modal')
    // this.router.navigate([
    //   '/content',
    //   !(i == undefined) ? i : this.scheduleDay,
    // ])
    return false
  }

  unlockReplay(i) {

    if (i == 0) {
      return
    }
    let dailyStepsArray = this.appState.get('DailyStepsData');
    let stepIndex = this.appState.get('reviewingStepIndex');
    let activeChapterIndex = this.appState.get('currentActiveChapter');
    //commenting 668 frontend change
    let stepData = dailyStepsArray[activeChapterIndex]?.steps[stepIndex]
      const reqData = {
        user_id: this.currentUser.id,
        path_id: this.currentPath.id,
        step: stepData?.position,
        step_id: stepData?.step?.id,
        platform: this.findCurrentPlatform(),
        original_step: stepData?.originalStep
      };
      this.routineService.startTime(reqData).subscribe( (response) => {
        console.log('post request succesful', response);
         mixpanel.track(` New step ${this.currentDay +1} is started from EOS in web`)
      }, (error) => {
        console.log('Error: ', error);
        this.toasterService.warning("Error, please check!");
      });

    let updateScheduleDay = i + 1
    let data = {
      'schedule_day': updateScheduleDay,
      'user_id': this.currentUser.id
    }

    // for(let s=i; s>=0; s--) {
    //   this.dayHasContent = this.currentPath.checkContentForDay(s);
    //   if (this.dayHasContent) {
    //     this.previousDayCompleted = !!this.homev5Service.checkPrevDayCompleted(
    //       this.pathRegistration,
    //       s,
    //       this.currentUser,
    //       this.currentPath
    //     )
    //     break;
    //   }
    // }

    // let stepsArray = this.homev5Service.removeDuplicates(this.pathRegistration.screensViewed, "step");
    // stepsArray.forEach(element => {
    //   if(element.step === this.scheduleDay && element.totalScreens === element.visitedScreens){
    //     this.previousDayCompleted = true
    //   }
    // });
    // if (this.previousDayCompleted) {

      this.homev5Service.updateScheduleDay(data).subscribe(
        (response) => {
                      mixpanel.track('Schedule day was updated during unlocking at EOS', {data:response, updatedScheduleDay:updateScheduleDay})
          if (response.success == true) {
            this.appState.set('allowScreenCount', true)
            this.appState.set('isNewStepUnlocked', true)
            this.appState.set('maxAllowedScheduleDay', updateScheduleDay)
            this.appState.set('currentScheduleDay', updateScheduleDay)
            this.appState.set('scheduleDayForCurrentStep', updateScheduleDay)
            this.appState.set('indexOfLevel', 0)
            this.appState.set('levelUpdated', undefined)
            // this.maxAllowedScheduleDay = this.appState.get(
            //   'maxAllowedScheduleDay'
            // ) // LUMBA-1379
            this.scheduleDay = this.appState.get('currentScheduleDay') // LUMBA-1379
            this.scheduledStep = this.appState.get('scheduleDayForCurrentStep')

            this.appState.set('LevelNumber', 1)

            localStorage.removeItem(
              `Toggle:User:${this.currentUser.id}:DayProgress:${this.currentPath.id}:${!(i == undefined) ? i + 1 : this.scheduledStep
              }`
            )
            // this.spinnerService.on()
            // this.router.navigate([
            //   '/content',
            //   !(i == undefined) ? i + 1 : this.scheduledStep,
            // ])
            this.modalController.dismiss({isOpenNextStep:true});
            this.homeUIService.openDailyStepsComponent(DailyStepsContentWebModalV2Component,{currentDay: !(i == undefined) ? i + 1 : this.scheduledStep},'web-daily-steps-custom-modal')
            return false

          } else {
            this.toasterService.warning(this.i18n.t('Server or connection issue. Please check your internet connection.'))
          }

        },
        (error) => {
          this.toasterService.warning(this.i18n.t('Server or connection issue. Please check your internet connection.'))
          console.log('Response of update  error', error)
        }
      )
    // } else {
    //   this.toasterService.warning(this.i18n.t('Please complete previous step'))
    // }
  }


  giveFeedback() {
    var step_rating = localStorage.getItem("step_score")
    var step_comment = localStorage.getItem("step_comment")
    try {
      const requestData = {
        'user_id': this.currentUser.id,
        'path_id': this.currentPath.id,
        'step_score': step_rating,
        'step_comment': step_comment,
        'step_id': this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.currentOpenedStep]?.step?.id,
        'step_version_id': this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.currentOpenedStep]?.stepVersion?.id
      }
      console.log('data', requestData)
      // this.spinnerService.on()
      if (requestData.step_comment == '' && requestData.step_score == '') {
        // this.spinnerService.off();
      } else {
        this.homev5Service.postStepFeedback(requestData).subscribe(
          (response) => {
            this.toasterService.success(this.i18n.t('Thank you for your feedback!'))
            this.cdRef.detectChanges()
            // this.spinnerService.off();
            this.onBackgroundTap();
            this.isIconDisliked = false;
            this.isIconLiked = false;
            this.postText = ''
            this.appState.set('isHomeScreen', true)
            this.showRatingBox = false
            this.showTyLabel = true
          },
          (error) => {
            this.toasterService.error(this.i18n.t('Server or connection issue. Please check your internet connection.'))
          }
        )
      }

    } catch (o_O) {
      console.log(o_O);

    }

  }

  // getTodaysTask() {
  //   if (this.inoutScreen) {
  //     this.titleOfTask = this.inoutScreen.homepageSubtext.text;
  //     return this.titleOfTask;
  //   }
  // }

  getActions(pathId: number) {
    const requestData = {
      'path_id': pathId
    }
    this.kyperApiService.getActionsList(requestData).subscribe((response) => {
      this.appState.set('todoActions',response.actions)
    }, (error) => {
      console.log('error :', error);
    })
    this.kyperApiService.getHabits(pathId);

  }

  animateReviewBox(formRating) {
    if (formRating >= 1) {
      this.isShrunken = false
      setTimeout(() => {
        this.isShrunken = true
      }, 10);

      this.expandTextArea = false
      setTimeout(() => {
        this.expandTextArea = true
      }, 10);
    }
  }
  toggleTheme() {
    this.homeUIService.toggleTheme();
    this.cdRef.detectChanges(); 
  }

  dislike(val) {
    if (!val) {
      this.isIconLiked = null;
        setTimeout(() => {
          this.isIconDisliked = true;
          
        }, 200);
    }
    this.showTextArea();    
  }

  like(val) {
    if (val) {
       this.isIconDisliked = null;    
       setTimeout(() => {
         this.isIconLiked = true;
       }, 220);
    }
    this.showTextArea();
  }

  nextStepEndScreen() {
    this.currentScreenIndex++;
  }
  
  onBackgroundTap() {
    if (this.showBottomTextarea && !this.showInstruction) {
      // this.keyboard.hide();
      setTimeout(() => {
        this.showBottomTextarea = false;
      }, 190);
      console.log("called on background", this.showBottomTextarea)
    }
  }
  showTextArea() {
   setTimeout(() => {
     this.showBottomTextarea = true;
   }, 190);   
    console.log("show textarea called", this.showBottomTextarea)
    this.animationBoard = false;
    setTimeout(() => {
      this.animationBoard = true;
     
      this.txtarea?.nativeElement?.focus();
    }, 200);  
  }

  onTextareaFocus() {
    let id = document.getElementsByClassName("rate-wrap");
    if (id && this.isAndroidTablet) {
       id[0]?.setAttribute(
            "style",
            "bottom:20% !important;margin: 9% 0 9%;"
          );
    }
  }
  checkBottomHeight() {

    let id = document.getElementsByClassName("rate-wrap");
      this.platform.ready().then(() => {
        this.keyboard.onKeyboardWillShow().subscribe((info) => { 
          if (id && this.isAndroidTablet) {

            id[0]?.setAttribute(
              "style",
              "bottom:20% !important;margin: 9% 0 9%;"
            );
          }
        });

        this.keyboard.onKeyboardWillHide().subscribe((info) => {
          if (id && this.isAndroidTablet) {

            id[0]?.setAttribute(
              "style",
              "bottom:11% !important; margin: 9% 0 9%;"
            );
          }
        });
      })
    
  }
  @HostListener('touchend', ['$event'])
    onTouchEnd(event: TouchEvent) {
      this.addInputEventListeners();
  }
  addInputEventListeners() {
    const inputs = document.querySelector("textarea");
    let id = document.getElementsByClassName("rate-wrap");
    if (inputs) {
          this.renderer.listen(inputs, "focus", () => {
       if (id && this.isAndroidTablet) {
         id[0]?.setAttribute(
           "style",
           "bottom:20% !important; margin: 9% 0 9%;"
         );
       }
    });

    this.renderer.listen(inputs, "blur", () => {
      if (id && this.isAndroidTablet) {
        id[0]?.setAttribute("style", "bottom:11% !important; margin: 9% 0 9%;");
      }
    });
    this.renderer.listen(inputs, "focusout", () => {
     if (id && this.isAndroidTablet) {
       id[0]?.setAttribute("style", "bottom:11% !important; margin: 9% 0 9%;");
     }
    });
    }

  }
   removeInputEventListeners() {
    const inputs = document.querySelector("textarea");
    if (inputs) {
       this.renderer.listen(inputs, "focus", null);
       this.renderer.listen(inputs, "blur", null);
       this.renderer.listen(inputs, "focusout", null);
    }
   
  }
  expandBadges(val) {
    this.isBadgesExpanded = val;
  }
  changeFont() {
  
    const element = this.stepTitle?.nativeElement;
    const specificElement = element?.querySelector('p') || element?.querySelector('h1') || element?.querySelector('h2');
    if(specificElement) {
      this.renderer.setStyle(specificElement, 'font-size', '16px');
      this.renderer.setStyle(specificElement, 'font-weight', '400');
      this.renderer.setStyle(specificElement, 'font-style', 'normal');
      this.renderer.setStyle(specificElement, 'line-height', 'normal');
      this.renderer.setStyle(specificElement, "font-family", "Roboto");
      this.renderer.setStyle(specificElement, "margin-bottom", "0px");
     this.renderer.setStyle(specificElement, "word-break", "break-word");
     this.renderer.setStyle(specificElement, "overflow", "hidden");
     this.renderer.setStyle(specificElement, " text-overflow", "ellipsis");
     this.renderer.setStyle(specificElement, "display", "-webkit-box");
     this.renderer.setStyle(specificElement, "-webkit-line-clamp", "2");
     this.renderer.setStyle(specificElement, "-webkit-box-orient", "vertical");

    }
  return true;
  }
  getTaskDurations() {
     if (this.currentDay < this.currentPath?.lastDayOfContent() && this.dailyStepsArray[this.currentOpenedChapter]?.steps?.length > this.currentOpenedStep + 1) {
      this.inoutScreen = this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.currentOpenedStep + 1]?.step
    }
    else if (this.dailyStepsArray?.length > this.currentOpenedChapter+1 && this.dailyStepsArray[this.currentOpenedChapter+1]?.steps?.length > 0) {
      this.inoutScreen = this.dailyStepsArray[this.currentOpenedChapter +1]?.steps[0]?.step
    }
    if (this.inoutScreen && !_.isUndefined(this.inoutScreen)) {
      if (this.inoutScreen?.stime && this.inoutScreen?.etime) {
        this.durationOfTask =
          this.inoutScreen.stime + " - " + this.inoutScreen.etime;
        return this.durationOfTask;
      } else if (!this.inoutScreen?.stime && this.inoutScreen?.etime) {
        this.durationOfTask = this.inoutScreen.etime;
        return this.durationOfTask;
      } else {
        return "5 - 10";
      }
    } else {
      return "5 - 10";
    }
    }

  /** Written when the first-time end-of-step is shown; removed again only by the back arrow. */
  /** The learner has now seen this step's first-time end-of-step. */
  markEndOfStepSeen() {
    try { localStorage.setItem(this.endOfStepSeenKey(this.currentDay), 'yes') } catch (e) { /* storage unavailable */ }
  }

  /** Undo it: the back arrow returns to the step, so the end-of-step is unseen again. */
  clearEndOfStepSeen() {
    try { localStorage.removeItem(this.endOfStepSeenKey(this.currentDay)) } catch (e) { /* storage unavailable */ }
  }

  /**
   * Is the view on screen the FIRST-VISIT end-of-step, as opposed to a review of a finished step?
   * Set where that view is built, which is also where the step is marked seen.
   */
  showingFirstVisitEndOfStep = false;

  endOfStepSeenKey(step: number): string {
    return `Toggle:User:${this.currentUser?.id}:EOSSeen:${this.currentPath?.id}:${step}`
  }

  restartStep(val,day) {
    this.modalController.dismiss();
    this.appState.set("isCurrentStepRestarted", val)
    this.appState.set('currentScheduleDay', day);
    if(day==this.currentDay){
      this.appState.set('reviewingStepIndex', this.currentOpenedStep)
      this.homeUIService.openDailyStepsComponent(DailyStepsContentWebModalV2Component,{currentDay: day, currentOpenedChapter: this.currentOpenedChapter},'web-daily-steps-custom-modal')
    }
    else 
    {
      let chapterInfo = this.currentPath.findChapterAndStepIndex(this.dailyStepsArray, day);
      this.appState.set('reviewingStepIndex', chapterInfo?.stepIndex)
      this.homeUIService.openDailyStepsComponent(DailyStepsContentWebModalV2Component,{currentDay: day, currentOpenedChapter: chapterInfo?.chapterIndex},'web-daily-steps-custom-modal')
    }
  }
  moveToLastScreen() {
    // The back arrow: returning to the step rather than finishing with the end-of-step, so it must
    // still be unseen when the learner comes back to it.
    // Only the first-visit view can be un-seen. Reviewing a finished step never marked anything,
    // so clearing here would wipe the marker left from when the step was genuinely completed — and
    // the next Next would then replay the first-visit flow for an already-finished step.
    if (this.showingFirstVisitEndOfStep) { this.clearEndOfStepSeen(); }
    let screenIds = this.appState.get('currentStepScreenIds')
    this.modalController.dismiss();
    console.log("screenIDS", screenIds);
    setTimeout(() => {
      this.appState.set('reviewingStepIndex', this.currentOpenedStep)
      this.appState.set('currentScheduleDay', this.currentDay);
      this.homeUIService.openDailyStepsComponent(DailyStepsContentWebModalV2Component, { currentDay: this.currentDay,currentOpenedChapter: this.currentOpenedChapter,startFromScreen: screenIds[screenIds?.length - 1] }, 'web-daily-steps-custom-modal')
    }, 550);
  }

  close(){
    this.modalController.dismiss();
  }
  ngOnDestroy(): void {
    // this.appState.set("isCurrentStepRestarted", false);
    this.appState.set("stepScreenIds", null);
     if (!this.appState.get("isCurrentStepRestarted")) {
      this.appState.set('isStreaksInfoUpdated', false)
      this.appState.set('updatedStreaksInfo', null);
    }
    this.appState.set('currentStepScreenIds', null)
    this.removeInputEventListeners();
  }
  
}
